import React from 'react'; 
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import LoginButton from './Login/LoginButton'
import LoggedButton from './Logged/LoggedButton'
import img from './../../../Icone/logo.png'
import img_pvs from './../../../Icone/privasee_inc.png'
require('./second-nav.css')
/*
	this class represent the header you can find on each page of our website it contains link to our different pages.
	It contains a drop down button in LoggedButton.tsx
	or two button sing in and sign up in LoginButton.tsx 
*/
interface HeaderProps {

}

interface HeaderState {
}

export default class Header extends React.Component<HeaderProps, HeaderState> {

	constructor(props: HeaderProps) {
		super(props)
		this.state = {
		}

	}

	render() {
		const AccessToken = localStorage.getItem('AccessToken')
		
		return (
				<div id="grid" className="hide_background">
					<div id="head-body">
					<Navbar bg="#494949" expand="lg" collapseOnSelect className="navbar-global">
						<Navbar.Brand className="navbar-brand">
							<img id="logo-ac" alt="logo-ac" src={img_pvs} width="4%"></img>
							<a id="name_nav" className="navbar-brandname" href="/accueil">PrivaSee</a>
						</Navbar.Brand>
						<Navbar.Toggle aria-controls="basic-navbar-nav" />
						<Navbar.Collapse id="basic-navbar-nav" className="navbar-collapse-responsive">
							<Nav className="ml-auto navbar-menu-responsive">
								<NavItem className="navbar-links">
									<li className="active">
										<a id="nav-head" className="nav-link" href="/accueil">Accueil <span className="sr-only">(current)</span></a>
									</li>
								</NavItem>
								<NavItem className="navbar-links">
									<li className="">
										<a id="nav-head" className="nav-link" href="/service">Nos services</a>
									</li>
								</NavItem>
								<NavItem className="navbar-links navbar-contact">
									<li className="">
										<a id="nav-head" className="nav-link" href="/contact">Nous Contacter</a>
									</li>
								</NavItem>
								<NavItem className="login-buttons navbar-contact">
									{AccessToken === null && <LoginButton/>}
									{AccessToken !== null && <LoggedButton/>}
								</NavItem>
							</Nav>
						</Navbar.Collapse>
					</Navbar>
					</div>
				</div>
		);
	}

}